import { Link } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';
import { useAuth } from '../context/AuthContext';
import {
    TERMS_DEFINITIONS,
    TERMS_INTRO,
    TERMS_PUBLISHED_DATE,
    TERMS_SECTIONS,
} from './terms/termsContent';
import './TermsPage.scss';

function renderPart(part, key) {
    if (part.type === 'text') {
        return <span key={key}>{part.value}</span>;
    }

    if (part.type === 'link') {
        return (
            <Link key={key} to={part.to}>
                {part.value}
            </Link>
        );
    }

    return null;
}

function TermsBlock({ block }) {
    if (block.type === 'subheading') {
        return <h3 className="terms-page__subheading">{block.text}</h3>;
    }

    if (block.type === 'p') {
        return (
            <p className="terms-page__text">
                {block.parts
                    ? block.parts.map((part, index) => renderPart(part, index))
                    : block.text}
            </p>
        );
    }

    if (block.type === 'clause') {
        return (
            <p className="terms-page__clause">
                <span className="terms-page__clause-id">{block.id}</span>
                <span className="terms-page__clause-text">
                    {block.parts
                        ? block.parts.map((part, index) => renderPart(part, index))
                        : block.text}
                </span>
            </p>
        );
    }

    return null;
}

function TermsSection({ section }) {
    return (
        <section className="terms-page__section" aria-labelledby={section.id}>
            <h2 id={section.id} className="terms-page__section-title">
                {section.title}
            </h2>

            {section.blocks?.map((block, index) => (
                <TermsBlock key={`${section.id}-${index}`} block={block} />
            ))}
        </section>
    );
}

export default function TermsPage() {
    const { isAuthenticated } = useAuth();
    const backTo = isAuthenticated ? '/subscriptions' : '/login';
    const backLabel = isAuthenticated ? 'К моим подпискам' : 'На страницу входа';

    return (
        <div className="terms-page">
            <article className="terms-page__article">
                <header className="terms-page__hero">
                    <h1 className="terms-page__title">Правила использования сайта</h1>
                </header>

                <div className="terms-page__intro">
                    {TERMS_INTRO.map((paragraph) => (
                        <p key={paragraph} className="terms-page__text">
                            {paragraph}
                        </p>
                    ))}
                </div>

                <section className="terms-page__section" aria-labelledby="terms-definitions">
                    <h2 id="terms-definitions" className="terms-page__section-title">
                        Термины и определения
                    </h2>
                    <dl className="terms-page__definitions">
                        {TERMS_DEFINITIONS.map((item) => (
                            <div key={item.term} className="terms-page__definition">
                                <dt>{item.term}</dt>
                                <dd>{item.text}</dd>
                            </div>
                        ))}
                    </dl>
                </section>

                {TERMS_SECTIONS.map((section) => (
                    <TermsSection key={section.id} section={section} />
                ))}

                <footer className="terms-page__footer">
                    <p className="terms-page__version">
                        Дата опубликования версии:
                        {' '}
                        {TERMS_PUBLISHED_DATE}
                    </p>
                </footer>
            </article>

            <Link to={backTo} className="btn btn--primary btn--fixed terms-page__back">
                <IconArrowLeft size={18} stroke={1.5} />
                {backLabel}
            </Link>
        </div>
    );
}
